import React, { useState, Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CheckCircleIcon, XCircleIcon, InfoIcon } from 'lucide-react';
import { FormSection, DisplayField, TextAreaField } from '../components/FormComponents';
import { StatusBadge } from '../components/StatusBadge';
// Inline mock data for QC with mixed types
const mockQCLineItems = [{
  id: 'l1',
  type: 'Goods',
  product: 'Laptop Pro X',
  description: 'High performance laptops for dev team',
  receivedQty: 5,
  approvedQty: 5,
  rejectedQty: 0,
  lossQty: 0,
  status: 'Pending'
}, {
  id: 'l2',
  type: 'Service',
  product: 'IT Setup Service',
  description: 'Initial configuration and setup',
  receivedQty: 1,
  approvedQty: 0,
  rejectedQty: 0,
  lossQty: 0,
  status: 'Pending'
}, {
  id: 'l3',
  type: 'Works',
  product: 'Network Cabling',
  description: 'Office floor network installation',
  receivedQty: 1,
  approvedQty: 0,
  rejectedQty: 0,
  lossQty: 0,
  status: 'Pending'
}];
export function QCAction() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const [remarks, setRemarks] = useState('');
  const [lineItems, setLineItems] = useState(mockQCLineItems);
  // Mock header data
  const data = {
    qcStatus: 'Pending',
    linkedPONo: 'PO-2023-001',
    linkedReceiveNo: 'RCV-2023-001',
    deliveryPhase: 'Phase 1',
    vendor: 'TechCorp Solutions',
    department: 'IT-01',
    qcReferenceNo: 'QC-2023-001',
    warehouse: 'Main Hub',
    qcInspector: 'Quality Manager',
    inspectionDate: '2023-11-15',
    receiveDate: '2023-11-14'
  };
  const handleLineItemChange = (itemId: string, field: string, value: any) => {
    setLineItems(items => items.map(item => {
      if (item.id === itemId) {
        return {
          ...item,
          [field]: value
        };
      }
      return item;
    }));
  };
  const handleAction = () => {
    alert('QC Inspection submitted successfully!');
    navigate(-1);
  };
  return <div className="space-y-6 max-w-6xl mx-auto" data-id="element-1700">
      <div className="flex items-center justify-between" data-id="element-1701">
        <div data-id="element-1702">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1703">QC Action</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1704">
            Review inspection details and approve/reject line items.
          </p>
        </div>
        <StatusBadge status={data.qcStatus} className="text-sm px-3 py-1" data-id="element-1705" />
      </div>

      <div className="bg-white shadow-sm rounded-lg border border-gray-200 p-6 md:p-8 space-y-8" data-id="element-1706">
        <FormSection title="PO & Receive Information" data-id="element-1707">
          <DisplayField label="PO No" value={data.linkedPONo} data-id="element-1708" />
          <DisplayField label="Receive No" value={data.linkedReceiveNo} data-id="element-1709" />
          <DisplayField label="Delivery Phase" value={<span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800" data-id="element-1711">
                {data.deliveryPhase}
              </span>} data-id="element-1710" />
          <DisplayField label="Receive Date" value={data.receiveDate} data-id="element-1712" />
          <DisplayField label="Vendor" value={data.vendor} data-id="element-1713" />
          <DisplayField label="Department" value={data.department} data-id="element-1714" />

          <div className="md:col-span-2 mt-4" data-id="element-1715">
            <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-1716">
              Selected Delivery Phase
            </h4>
            <div className="overflow-hidden border border-gray-200 rounded-md" data-id="element-1717">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-1718">
                <thead className="bg-gray-50" data-id="element-1719">
                  <tr data-id="element-1720">
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1721">
                      Phase
                    </th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1722">
                      Receive No
                    </th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1723">
                      Delivery Date
                    </th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1724">
                      Items Received
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-1725">
                  <tr className="bg-indigo-50 border-l-4 border-indigo-500" data-id="element-1726">
                    <td className="px-4 py-2 text-sm font-medium text-indigo-700" data-id="element-1727">
                      Phase 1 (Current)
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-700" data-id="element-1728">
                      RCV-2023-001
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-700" data-id="element-1729">
                      2023-11-14
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-700" data-id="element-1730">
                      3 items (2 Goods, 1 Service)
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </FormSection>

        <FormSection title="QC Details" data-id="element-1731">
          <DisplayField label="QC Ref No" value={data.qcReferenceNo} data-id="element-1732" />
          <DisplayField label="Warehouse" value={data.warehouse} data-id="element-1733" />
          <DisplayField label="QC Inspector" value={data.qcInspector} data-id="element-1734" />
          <DisplayField label="Inspection Date" value={data.inspectionDate} data-id="element-1735" />
        </FormSection>

        <div className="mb-8" data-id="element-1736">
          <h3 className="text-lg font-medium text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-1737">
            Line Items QC Inspection
          </h3>

          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6" data-id="element-1738">
            <div className="flex" data-id="element-1739">
              <div className="flex-shrink-0" data-id="element-1740">
                <InfoIcon className="h-5 w-5 text-blue-400" data-id="element-1741" />
              </div>
              <div className="ml-3" data-id="element-1742">
                <p className="text-sm text-blue-700" data-id="element-1743">
                  <strong data-id="element-1744">Note:</strong> Approved quantity for{' '}
                  <strong data-id="element-1745">Goods</strong> will automatically hit stock inventory.
                  <strong data-id="element-1746"> Works</strong> and <strong data-id="element-1747">Service</strong> items do
                  not affect stock inventory.
                </p>
              </div>
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-1748">
            <table className="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-md" data-id="element-1749">
              <thead className="bg-gray-50" data-id="element-1750">
                <tr data-id="element-1751">
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase w-24" data-id="element-1752">
                    Type
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1753">
                    Product & Description
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase w-24" data-id="element-1754">
                    Received
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1755">
                    QC Inspection Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1756">
                {lineItems.map(item => <tr key={item.id} data-id="element-1757">
                    <td className="px-4 py-4 text-sm" data-id="element-1758">
                      <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${item.type === 'Goods' ? 'bg-blue-100 text-blue-800' : item.type === 'Works' ? 'bg-orange-100 text-orange-800' : 'bg-purple-100 text-purple-800'}`} data-id="element-1759">
                        {item.type}
                      </span>
                    </td>
                    <td className="px-4 py-4" data-id="element-1760">
                      <div className="text-sm font-medium text-gray-900" data-id="element-1761">
                        {item.product}
                      </div>
                      <div className="text-xs text-gray-500 mt-1" data-id="element-1762">
                        {item.description}
                      </div>
                    </td>
                    <td className="px-4 py-4 text-sm font-medium text-gray-900" data-id="element-1763">
                      {item.receivedQty}
                    </td>
                    <td className="px-4 py-4" data-id="element-1764">
                      {item.type === 'Goods' ? <div className="flex space-x-3" data-id="element-1765">
                          <div data-id="element-1766">
                            <label className="block text-xs text-gray-500 mb-1" data-id="element-1767">
                              Approved Qty
                            </label>
                            <input type="number" min="0" max={item.receivedQty} className="block w-20 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm border p-1.5" value={item.approvedQty} onChange={e => handleLineItemChange(item.id, 'approvedQty', Number(e.target.value))} data-id="element-1768" />
                          </div>
                          <div data-id="element-1769">
                            <label className="block text-xs text-gray-500 mb-1" data-id="element-1770">
                              Rejected Qty
                            </label>
                            <input type="number" min="0" max={item.receivedQty} className="block w-20 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm border p-1.5" value={item.rejectedQty} onChange={e => handleLineItemChange(item.id, 'rejectedQty', Number(e.target.value))} data-id="element-1771" />
                          </div>
                          <div data-id="element-1772">
                            <label className="block text-xs text-gray-500 mb-1" data-id="element-1773">
                              Loss Qty
                            </label>
                            <input type="number" min="0" max={item.receivedQty} className="block w-20 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm border p-1.5" value={item.lossQty} onChange={e => handleLineItemChange(item.id, 'lossQty', Number(e.target.value))} data-id="element-1774" />
                          </div>
                        </div> : <div className="flex items-center space-x-4 h-full pt-4" data-id="element-1775">
                          <label className="inline-flex items-center" data-id="element-1776">
                            <input type="radio" name={`status-${item.id}`} className="h-4 w-4 text-green-600 border-gray-300 focus:ring-green-500" checked={item.status === 'Approved'} onChange={() => handleLineItemChange(item.id, 'status', 'Approved')} data-id="element-1777" />
                            <span className="ml-2 text-sm text-gray-700" data-id="element-1778">
                              Approve
                            </span>
                          </label>
                          <label className="inline-flex items-center" data-id="element-1779">
                            <input type="radio" name={`status-${item.id}`} className="h-4 w-4 text-red-600 border-gray-300 focus:ring-red-500" checked={item.status === 'Rejected'} onChange={() => handleLineItemChange(item.id, 'status', 'Rejected')} data-id="element-1780" />
                            <span className="ml-2 text-sm text-gray-700" data-id="element-1781">
                              Reject
                            </span>
                          </label>
                        </div>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8" data-id="element-1782">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1783">
            Overall QC Remarks
          </h3>
          <TextAreaField label="Inspector Remarks" name="remarks" value={remarks} onChange={e => setRemarks(e.target.value)} placeholder="Enter overall remarks for this inspection..." rows={3} data-id="element-1784" />

          <div className="mt-6 flex justify-end" data-id="element-1785">
            <button onClick={handleAction} className="inline-flex justify-center items-center px-6 py-3 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-1786">
              <CheckCircleIcon className="h-5 w-5 mr-2" data-id="element-1787" /> Submit QC Inspection
            </button>
          </div>
        </div>
      </div>
    </div>;
}